<template>
  <div>
    <div class="dashboard-page-title">
      <div class="container-fluid">
        <h1>
          Inbox
          <help-link v-if="!$vlastMode" anchor="chat" />
        </h1>
      </div>
    </div>
    <div class="container-fluid">

      <div class="dashboard-results-details">
        <div class="flex flex-wrap justify-between spacer-b-2">
          <div class="count"><span>{{ pagination.total }}</span> Threads</div>
          <thread-list-sort
            :set-filter-mutation="setFilter"
            :filters="filters"
          />
        </div>
      </div>

      <thread-list-filters
        :set-filter-mutation="setFilter"
        :filters="filters"
        :apply-filters="handleApplyFiltersCallback">
        <ladda-button
          slot="button"
          :click="handleApplyFiltersCallback"
          :disabled="$userIsInactiveManager"
          type="submit"
          class="btn btn-primary">
          Search
        </ladda-button>
      </thread-list-filters>
      <div class="dashboard-block">
        <ul class="nav nav-tabs" role="tablist" v-if="$userIsAdmin">
          <li :class="{ 'active': status === 'active' }">
            <router-link :to="{ params: { status: 'active' }, query: $route.query }">Active</router-link>
          </li>
          <li :class="{ 'active': status === 'pinned' }">
            <router-link :to="{ params: { status: 'pinned' }, query: $route.query }">Pinned</router-link>
          </li>
          <li :class="{ 'active': status === 'archived' }">
            <router-link :to="{ params: { status: 'archived' }, query: $route.query }">Archived</router-link>
          </li>
        </ul>

        <pickstar-loading v-if="fetchingThreads" class="m-t-lg"/>

        <template v-else>
          <no-results v-if="$userIsInactiveManager" class="text-center">
            <div>
              You will be able to view chats once {{ clientName }} has approved your account. In the meantime,
              build out your <router-link :to="{ name: 'profile.show' }">profile</router-link> or start
              <router-link :to="{ name: 'talent.index' }">adding your {{ $starLabelPlural }} for review!</router-link>
            </div>
          </no-results>
          <no-results v-else-if="haveNoThreads">
            <div>There are no threads.</div>

            <button v-if="haveAppliedFilters" @click="handleResetFiltersCallback" class="btn btn-default btn-sm m-t-sm">Reset Filters</button>
          </no-results>

          <ul class="list-items">
            <thread-list-item
              v-for="thread in threadList"
              :key="thread.id"
              :thread="thread"
              :booking="thread.booking"/>
          </ul>

          <lazy-loading
            v-if="!$userIsInactiveManager"
            class="text-center"
            :loading="loading"
            :reached-bottom="handleGetNextThreadsCallback"
            ref="lazyLoading">
            <pickstar-loading slot="loading"/>
            <span slot="finished"></span>
          </lazy-loading>
        </template>
      </div>
    </div>
  </div>
</template>

<script>
import ThreadListItem from './ThreadListItem'
import { assign } from 'lodash'
import LazyLoading from 'codium-lazy-loading'
import { mapActions, mapState, mapGetters } from 'vuex'
import ThreadListFilters from './ThreadListFilters'
import { appliesFilters } from 'mixins'
import ThreadListSort from './ThreadListSort'
import HelpLink from 'components/globals/HelpLink'

export default {
  mixins: [appliesFilters],

  data () {
    return {
      search: '',
      fetchingThreads: false
    }
  },

  props: {
    status: {
      required: false,
      default: 'active'
    }
  },

  components: {
    ThreadListSort,
    ThreadListFilters,
    ThreadListItem,
    LazyLoading,
    HelpLink
  },
  computed: {
    ...mapState('message', ['thread', 'threads', 'pagination', 'unread_count', 'filters']),
    ...mapState('app', ['loading']),
    ...mapGetters('message', ['initialFiltersState']),

    haveNoThreads () {
      return this.threads.length === 0
    },

    threadList () {
      return this.threads
    }
  },

  watch: {
    '$route' () {
      if (!this.$userIsInactiveManager) {
        this.handleGetThreadsCallback()
      }
    }
  },

  created () {
    if (!this.$userIsInactiveManager) {
      this.handleGetThreadsCallback()
    }
  },

  methods: {
    ...mapActions('message', ['getThreads', 'getNextThreads', 'setFilter', 'resetFilters']),

    handleGetThreadsCallback () {
      this.fetchingThreads = true

      return this.getThreads(this.queryParams)
        .catch(this.handleServerErrorsCallback)
        .finally(() => {
          this.fetchingThreads = false

          this.$nextTick(() => {
            if (!this.$refs.lazyLoading) {
              return
            }

            this.$refs.lazyLoading.$emit('reset')
          })
        })
    },

    handleGetNextThreadsCallback () {
      return this.getNextThreads(this.queryParams)
        .catch(this.handleServerErrorsCallback)
    },

    /**
     * Handle searching the additional talent.
     *
     * @return Promise
     */
    handleSearchThreadsCallback () {
      this.fetchingThreads = true
      let query = assign({}, this.$route.query)
      query.search = this.search

      return this.getThreads(this.queryParams)
        .catch(this.handleServerErrorsCallback)
        .finally(() => {
          this.fetchingThreads = false
        })
    }
  }
}
</script>
